import { BREAKPOINT_WIDTH } from './constants'
export const isDesktop = () => {
  return (
    window.outerWidth > BREAKPOINT_WIDTH && window.innerWidth > BREAKPOINT_WIDTH
  )
}

import { ID_DATA } from '~/js/constants/data-element-ids'
const dataElement = document.getElementById(ID_DATA)
export const isLogin = dataElement?.dataset.isLogin
export const favouriteArticleHandles =
  dataElement?.dataset.favouriteArticleHandles.split(',')
export const favouriteCoordinateHandles =
  dataElement?.dataset.favouriteCoordinateHandles.split(',')
export const favouriteProductHandles =
  dataElement?.dataset.favouriteProductHandles.split(',')
export const favouriteHashtagHandles =
  dataElement?.dataset.favouriteHashtagHandles.split(',')
export const baseUrlFrontApi = dataElement?.dataset.baseUrlFrontNamed
